import React from 'react';

import BoiteATraiter from './BoiteATraiter';
import Cloche from './Cloche';
import FilAriane from './FilAriane';
import RechercheGlobale from './RechercheGlobale';

/**
 * La barre du haut de la coquille du gestionnaire (Yros/Kavero#416) : où
 * l'on est, ce qui attend, et de quoi aller ailleurs sans passer par le
 * menu.
 */
const BarreHaute = ({ user }) => (
  <div className="mb-4 flex items-center gap-3">
    <div className="min-w-0 flex-1">
      <FilAriane user={user} />
    </div>
    <BoiteATraiter />
    <Cloche user={user} />
    <RechercheGlobale user={user} />
  </div>
);

export default BarreHaute;
